import request from "@/utils/request";
import requestgpt from "@/utils/requestgpt";
import newsRRequest from "@/utils/newsRequest";
// 获取验证码
export function getVerifyCode(data) {
  return request({
    url: "/tools/get-verify-code",
    method: "post",
    data,
    noAuth: true
  });
}
// 验证码登录
export function verifyCodeLogin(data) {
  return request({
    url: "/sso/login/verify-code",
    method: "post",
    data,
    noAuth: true
  });
}
// 登录获取token
export function handleLogin(data) {
  return request({
    url: "/sso/login",
    method: "post",
    data,
    noAuth: true
  });
}

// 获取gpt页面登录token
export function handleGptLogin(data) {
  return requestgpt({
    url: "/login/verify-code",
    method: "post",
    data,
    noAuth: true
  });
}
// chatgpt获取答案
export function preferredNew(data) {
  return requestgpt({
    url: "/chat/get-answer",
    method: "post",
    data,
  });
}
// chatgpt获取答案(wx)
export function preferredWx(data) {
  return requestgpt({
    url: "/chat/get-answer",
    method: "post",
    data,
    noAuth: true
  });
}
// chatgpt获取答案(wx)(新)
export function newPreferredWx(data) {
  return requestgpt({
    url: "/chatgpt/v1",
    method: "post",
    data,
    noAuth: true
  });
}
// chatgpt获取图片(wx)
export function getImgWx(data) {
  return requestgpt({
    url: "/chatgpt/img",
    method: "post",
    data,
    noAuth: true
  });
}
export function preferredCj(data) {
  return requestgpt({
    url: "/gpt_index",
    method: "post",
    data,
    noAuth: true
  });
}
// lsfchatgpt获取答案
export function preferredLsf(data) {
  return requestgpt({
    url: "/faq",
    method: "post",
    data,
    noAuth: true
  });
}
// lsfchatgpt 新的获取答案
export function preferredLsf2(data) {
  return requestgpt({
    url: "/faq3",
    method: "post",
    data,
    noAuth: true
  });
}
// 邀请链接注册
export function handleRegister(data) {
  return request({
    url: "/sso/register",
    method: "post",
    data,
    noAuth: true
  });
}
// 绑定手机号
export function bindPhone(data) {
  return request({
    url: "/weixin/associate-weixin",
    method: "post",
    data,
    noAuth: true
  });
}


// 通过associatedCode获取用户token
export function getToken(data) {
  return request({
    url: "/sso/login/get-token",
    method: "post",
    data,
    noAuth: true
  });
}
//获取当前用户基本信息
export function getUserConfig(data) {
  return request({
    url: "/get-enterprise-config",
    method: "get"
  });
}

// 获取行业报告列表
export function getReportList(data) {
  return request({
    url: `/type/list-report?type=${data.type}&pageSize=${data.pageSize}&pageNum=${data.pageNum}`,
    method: "get",
  });
}

// 获取问答初始列表
export function getDomainList(data) {
  return request({
    url: "/list-domain",
    method: "get"
  });
}

// 获取问答答案
export function getAnser(data) {
  return request({
    url: "/list-new-question-answer?id=" + data.id,
    method: "get"
  });
}

// 获取新闻列表
export function getNewsList(data) {
  return newsRRequest({
    url: `/car/news/page-news?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: "get"
  });
}

// 获取新闻详情
export function getNewsDetail(data) {
  return newsRRequest({
    url: `/car/news/detail?id=${data.id}`,
    method: "get"
  });
}

// export function wattleAccount(data) {
//   return request({
//     url: "/gameBox/adv/agent/getWattleAccount",
//     method: "post",
//     data
//   });
// }

// 微信登录
// 获取微信登录授权链接
export function getWeixinLoginUrl() {
  return request({
    url: `/sso/weixin/get-login-url`,
    method: "get"
  });
}

// 获取用户扫码状态
export function getScancode(data) {
  return request({
    url: "/sso/weixin/scan-code",
    method: "post",
    data
  });
}

// 获取用户绑定的公司列表
export function getCompanyList(data) {
  return request({
    url: "/user/list-enterprise",
    method: "post",
    data,
    noAuth: true
  });
}

// 微信扫码获取token
export function weixinLoginToken(data) {
  return request({
    url: `/sso/weixin/login`,
    method: "post",
    data,
    noAuth: true
  });
}

// 公众号获取pdf列表
export function getReportListAll(data) {
  return request({
    url: `/report/type?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=${data.type}`,
    noAuth: true,
    method: "get"
  });
}
// 公众号获取新闻列表
export function getNewsListAll(data) {
  return newsRRequest({
    url: `/news/wexin?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    noAuth: true,
    method: "get"
  });
}

// 公众号获取新闻类型
export function getTypeList(data) {
  return request({
    url: `/report/list-type`,
    noAuth: true,
    method: "get"
  });
}

// 问答赞、踩
export function feedback(data) {
  return requestgpt({
    url: `/sync-feedback`,
    method: "post",
    data,
    noAuth: true,
    env: 'prod'
  });
}



// 表格筛选
export function positionSort(data) {
  return requestgpt({
    url: `/PositionSort`,
    method: "post",
    data,
    noAuth: true
  });
}

// 获取问题相关问题列表
export function possiblyAsk(data) {
  return requestgpt({
    url: `/possibly-ask`,
    method: "post",
    data,
    noAuth: true
  });
}

export function possiblyAskByProd(data) {
  return requestgpt({
    url: `/possibly-ask`,
    method: "post",
    data,
    noAuth: true,
    env: 'prod',
  });
}


export function hisConver(data) {
  return requestgpt({
    url: `/page-conversation-history`,
    method: "post",
    data,
    noAuth: true,
    env: 'prod',
  });
}
export function hisConverDev(data) {
  return requestgpt({
    url: `/page-conversation-history`,
    method: "post",
    data,
    noAuth: true,
    env: 'dev',
  });
}

// 获取专业列表
export function majorList(data) {
  return requestgpt({
    url: `/list-major`,
    noAuth: true,
    method: "get",
    env: 'prod',
  });
}
export function majorListDev(data) {
  return requestgpt({
    url: `/list-major`,
    noAuth: true,
    method: "get",
    env: 'dev',
  });
}

// 问卷提交
export function profile(data) {
  return requestgpt({
    url: `/sync-profile`,
    method: "post",
    data,
    noAuth: true,
    env: 'prod',
  });
}

export function profileDev(data) {
  return requestgpt({
    url: `/sync-profile`,
    method: "post",
    data,
    noAuth: true,
    env: 'dev',
  });
}

export function faq5(data) {
  return requestgpt({
    url: `/faq5`,
    method: "post",
    data,
    noAuth: true,
  });
}

// 获取历史对话列表
export function pageList(data) {
  return requestgpt({
    url: `/conversation/page-conversation`,
    method: "post",
    data,
    noAuth: true,
  });
}

// 开启新对话
export function insert(data) {
  return requestgpt({
    url: `/conversation/insert`,
    method: "post",
    data,
    noAuth: true,
  });
}
// 获取单个对话历史记录
export function pageHistory(data) {
  return requestgpt({
    url: `/conversation/page-history`,
    method: "post",
    data,
    noAuth: true,
  });
}
// 新增对话
export function addHis(data) {
  return requestgpt({
    url: `/conversation/add-hisotry`,
    method: "post",
    data,
    noAuth: true,
  });
}
// 获取历史对话列表
export function delHis(data) {
  return requestgpt({
    url: `/conversation/del`,
    method: "post",
    data,
    noAuth: true,
  });
}

// 获取推荐内容
export function getIntroduce(data) {
  return requestgpt({
    url: `/func-introduce`,
    method: "post",
    data,
    noAuth: true,
  });
}

// ========== Agent Demo API ==========
// 创建新对话线程
export function createConversation(data) {
  return requestgpt({
    url: `/api/conversations/new`,
    method: "post",
    data,
    noAuth: true,
  });
}

// 发送消息
export function sendChatMessage(data) {
  return requestgpt({
    url: `/api/chat`,
    method: "post",
    data,
    noAuth: true,
  });
}

// 获取对话列表
export function getConversations(params) {
  return requestgpt({
    url: `/api/conversations`,
    method: "get",
    params,
    noAuth: true,
  });
}

// 获取对话详情
export function getConversationDetail(conversationId, params) {
  return requestgpt({
    url: `/api/conversations/${conversationId}`,
    method: "get",
    params,
    noAuth: true,
  });
}

// 删除对话
export function deleteConversation(conversationId, params) {
  return requestgpt({
    url: `/api/conversations/${conversationId}`,
    method: "delete",
    params,
    noAuth: true,
  });
}


// WEBPACK FOOTER //
// ./src/utils/api.js